import { UseQueryResult } from '@tanstack/react-query';
import { BikeleasingV2ConditionDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';

export function useBikeleasingCondition(): UseQueryResult<BikeleasingV2ConditionDTO> {
  return useTenantQuery(
    ['bikeleasingV2', 'condition'],
    tenantId =>
      apis.bikeLeasingV2.getCondition({ tenantId }).then(res => {
        if (!res.data.condition) {
          return undefined;
        }
        return res.data.condition;
      }),
    { retry: false, staleTime: 10 * 60 * 1000 },
  );
}
